// ======================================================================
// File Name       : EnterpriseNotificationList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import PropTypes from 'prop-types';
import { Table, Button, Col, Form } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import TableHead from '../../components/TableHead';
import { getItemBoxName, parseDateForDetail } from '../../utils/index';
import { DEFAULT_DATE_FORMAT } from '../../constants/index';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import * as enterpriseNotificationConstant from '../../constants/enterpriseNotificationConstant';
import ReduxFormPaging from '../../components/ReduxFormPaging';
import CustomLink from '../button/CustomLink';
import * as ICON from '../../constants/IconConstants';
import { ENTERPRISE_NOTIFICATION_DETAIL } from '../../constants/PathConstants';

const thead = [
    { title: 'タイトル', sortBy: 0 },
    { title: '登録者', sortBy: null },
    { title: '公開範囲', sortBy: 1 },
    { title: '公開ステータス', sortBy: 2, width:'10%'},
    { title: '登録日', sortBy: 8, width:'15%'},
    { title: '操作', sortBy: null, width:'10%'},
];

class EnterpriseNotificationList extends React.Component {
  render() {
    const {
      noticeForEnterpriseList,
      invalid,
      handleSortState,
      goToDetail,
      recordNum,
      startPosition,
      getStartEndData,
    } = this.props;
    let tbody = null;
    if (noticeForEnterpriseList && noticeForEnterpriseList.allSecernIds && noticeForEnterpriseList.allSecernIds.length) {
      const bySecernId = noticeForEnterpriseList.bySecernId;
      tbody = noticeForEnterpriseList.allSecernIds.map((noticeForEnterpriseSecernId, index) => {
        if (!bySecernId && !bySecernId[noticeForEnterpriseSecernId]) {
          return null;
        }
        const {
          noticeTitle,
          noticeContent,
          releaseTargetForEnterprise,
          publicStatus,
          publicDateFrom,
          publicDateTo,
          authorSecernId,
          authorName,
          createdAt,
          updatedAt,
        } = bySecernId[noticeForEnterpriseSecernId];
        const changePublicStatus = (type) => {
          try {
            const typeInt = parseInt(type, 10);
            return enterpriseNotificationConstant.EnterpriseNotificationPublicStatus[typeInt].name;
          } catch (error) {
            return '';
          }
        };
        const changeReleaseTargetForEnterprise = (type) => {
          try {
            const typeInt = parseInt(type, 10);
            return enterpriseNotificationConstant.EnterpriseNotificationReleaseTargetForEnterprise[typeInt].name;
          } catch (error) {
            return '';
          }
        };
        const link = ENTERPRISE_NOTIFICATION_DETAIL.replace(':id', noticeForEnterpriseSecernId);
        return (
          <tr key={noticeForEnterpriseSecernId} onMouseEnter={() => this.props.handleMouseEnter(index)} onMouseLeave={() => this.props.handleMouseLeave()}>
            <td>
              {noticeTitle}
            </td>
            <td>
              {authorName}
            </td>
            <td>
              {changeReleaseTargetForEnterprise(releaseTargetForEnterprise)}
            </td>
            <td>
              {changePublicStatus(publicStatus)}
            </td>
            <td>
              {parseDateForDetail(createdAt, DEFAULT_DATE_FORMAT)}
            </td>
            <td className="text-center">
              <CustomLink
                className="margin-right-7 link-detail-edit"
                to={link}
                text="詳細"
              />
            </td>
          </tr>
        );
      });
    }
    return (
      <div>
        <Table striped hover>
          <thead>
            <ReduxFormPaging
              type="tableHead"
              data={thead}
              name="noticeSortType"
              invalid={invalid}
              handleSortState={handleSortState}
            />
          </thead>
          <tbody>{tbody}</tbody>
        </Table>
        <Form.Group>
            <Col className="d-flex justify-content-center">
              <ReduxFormPaging
                type="paging"
                name="startPosition"
                recordNum={recordNum}
                getStartEndData={getStartEndData}
              />
            </Col>
          </Form.Group>
      </div>
    );
  }
}

export default EnterpriseNotificationList;
